export default {
  getFile: async ({ tvId, zipCode, number, urlBase, productUrl }) => {

    try {
      const redirectResponse = await fetch('https://assets.clarobrasil.mobi/ecommerce-config/ecommerce-responsivo/config/grade-de-canais/de-para-grade.json');
      const redirect = await redirectResponse.json();
      const target = redirect.find(item => item.id === tvId);
      if (target) {
        const listResponse = await fetch(`https://assets.clarobrasil.mobi/ecommerce-config/ecommerce-responsivo/config/grade-de-canais/${target.group}.json`)
        const list = await listResponse.json();
        if (list) {
          list.planName = target.name || '';
          return list
        }
      }
      return { error: 'not found item' };
    } catch (e) {
      return { error: 'not found item' };
    }
  },
};
